module.exports = __webpack_public_path__ + "static/media/Pink_Button@3x.67cd66a3.png";